<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title
            class="primary accent--text title font-weight-thin mb-5"
          >
            {{ $t("user.page.user_account") }}
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="model.firstName"
                  dense
                  outlined
                  type="text"
                  :label="$t('user.page.placeholder.name')"
                  :rules="[required]"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="model.lastName"
                  dense
                  outlined
                  type="text"
                  :label="$t('user.page.placeholder.lastname')"
                  :rules="[required]"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="model.email"
                  dense
                  outlined
                  :disabled="isUpdateMode"
                  type="email"
                  :label="$t('user.page.placeholder.email')"
                  :rules="[required, email]"
                />
              </v-col>
              <v-col cols="12">
                <international-phone-number @change="onPhoneNumberChange" :init="model.phoneNumber" :disabled="isUpdateMode" />
              </v-col>
              <v-col cols="12">
                <roles-drop-down
                  @select-item="onRoleSelected"
                  :initRole="model.role"
                  :multiple="false"
                  :rules="[required]"
                />
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="sendInvite"
                  dense
                  color="primary"
                  :label="sendInviteLabel"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-divider class="mb-5" />
        <v-btn
          outlined
          rounded
          :disabled="!changesMade || actionButtonDisabled"
          :loading="isLoading"
          color="primary"
          class="mr-3"
          @click="save"
        >
          {{ $t("generic.button.save") }}
        </v-btn>

        <v-btn
          outlined
          rounded
          text
          @click="cancel"
        >
          {{ $t("generic.button.cancel") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import InternationalPhoneNumber from "@/components/Common/InternationalPhoneNumber";
import RolesDropDown from "@/components/Common/RolesDropDown";

export default {
  components: { InternationalPhoneNumber, RolesDropDown },
  props: {
    dialog: {
      type: Boolean,
    },
  },
  data() {
    return {
      isLoading: false,
      sendInvite: true,
      valid: true,
      user: {},
      model: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        role: "",
      },
    };
  },
  computed: {
    ...mapGetters([ 'getUser' ]),
    changesMade() {
      return JSON.stringify(this.model) !== JSON.stringify(this.user)
    },
    sendInviteLabel() {
      const fixedLabel = this.$t("user.page.send_invitation_option")
      const inviteLabel = this.sendInvite
        ? this.$t("generic.boolean.yes")
        : this.$t("generic.boolean.no")
      return `${fixedLabel} ${inviteLabel}`
    },
    actionButtonDisabled() {
      return (
        !this.valid ||
        !this.model.firstName ||
        !this.model.lastName ||
        !this.model.email ||
        !this.model.phoneNumber ||
        !this.model.role
      )
    },
    isUpdateMode() {
      return this.$route.params.action === 'E'
    },
  },
  created() {
    if (this.isUpdateMode) {
      // We store the original user to compute the change to enable the save button
      this.$store.dispatch('ensureUser', this.$route.params.id)
      this.user = this.getUser(this.$route.params.id)
      this.model = { ...this.user }
    }
  },
  methods: {
    ...mapActions(["createTenantUser", "updateTenantUser"]),
    onRoleSelected(role) {
      this.model = {
        ...this.model,
        role: role,
      };
    },
    onPhoneNumberChange(phone) {
      this.model = {
        ...this.model,
        phoneNumber: phone.number,
      };
    },
    endSaveUpdateAction() {
      setTimeout(() => {
        this.isLoading = false;
        this.$router.push({
          name: "users",
        });
      }, 2000);
    },
    async save() {
      const actionPerformed = 'generic.action_performed.'.concat(this.isUpdateMode ? 'updated' : 'created')

      const successMsg = this.$t('generic.message.success', [this.$t('entity.user'), this.$t(actionPerformed)])
      const errorMsg = this.$t('generic.message.error', [this.$t('entity.user'), this.$t(actionPerformed)])
      const payload = {
        ...this.model,
        sendInvite: this.sendInvite,
      }

      this.isLoading = true
      if (this.isUpdateMode) {
        await this.updateTenantUser(payload).then(() => {
            this.showSnackbar(successMsg, this.$t('generic.status.success'));
            this.endSaveUpdateAction();
          }).catch(() => {
            this.showSnackbar(errorMsg, this.$t('generic.status.error'));
          })
      } else {
        await this.createTenantUser(payload).then(() => {
          this.showSnackbar(successMsg, this.$t('generic.status.success'));
          this.endSaveUpdateAction();
        }).catch(() => {
          this.showSnackbar(errorMsg, this.$t('generic.status.error'));
        });
      }

      this.isLoading = false
    },
    emitSave() {
      this.$emit("save-form", { ...this.model });

      // This case is for when its the HeaderBarAction
      this.$emit("close-dialog", this.model.uid);
    },
    cancel() {
      this.$router.push({ name: "users" });
    },
  },
};
</script>
